import { IAdminUsersState } from 'types';

export const initState: IAdminUsersState = {
  users: null,
  isUsersLoading: false,
};
